// The floating bar a visitor sees in the public demo league, above the tab bar.
//
// Fixed navy in both themes rather than --color-cta: in dark mode that token
// turns green, and the green Sign up pill would vanish into it.
import React from "react";
import { useNavigate } from "react-router-dom";

const NAVY = "#071F39";

// aboveTabBar: the league pages have a fixed tab bar to clear; Home has none.
function DemoBar({ aboveTabBar = true }) {
  const navigate = useNavigate();

  return (
    <div
      className="demo-bar"
      role="region"
      aria-label="Demo league"
      style={{
        position: "fixed", left: 12, right: 12, zIndex: 45,
        bottom: aboveTabBar
          ? "calc(49px + env(safe-area-inset-bottom) + 12px)"
          : "calc(env(safe-area-inset-bottom) + 12px)",
        maxWidth: 576, margin: "0 auto",
        display: "flex", alignItems: "center", justifyContent: "space-between", gap: 10,
        backgroundColor: NAVY, color: "#FFFFFF",
        borderRadius: 16, padding: "12px 14px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.25)",
        fontSize: 13, lineHeight: 1.35,
      }}
    >
      <span>This is a demo league. Start your own in two minutes.</span>
      <button
        onClick={() => navigate("/signup")}
        style={{
          flexShrink: 0, border: "none", cursor: "pointer",
          backgroundColor: "var(--color-brand-green)", color: NAVY,
          fontWeight: 700, fontSize: 13, padding: "8px 14px", borderRadius: 50,
        }}
      >
        Sign up
      </button>
    </div>
  );
}

export default DemoBar;
